import React, { useState, useEffect, useRef } from "react";
import dashboardclasses from "../dashboard.module.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { GrFormView } from "react-icons/gr";
import "../../App.css";
import { Services } from "../../Services";
import { toast } from "react-toastify";
import { ToastError } from "../../Components/utils/ToastMessage";
import ScaleLoader from "react-spinners/ScaleLoader";
import { css } from "@emotion/react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Pushmodal from "./PushNotify/pushmodal";
import Moment from "react-moment";
import Layout from "../../Components/Layout/layout";
import swal from "sweetalert";
import ReactPaginate from "react-paginate";

function Warehouse() {
    const statusRef = useRef();
    const debounceTimerRef = useRef(null);

    const Navigate = useNavigate();
    const [params, setparams] = useSearchParams();
    const [searchTerm, setSearchTerm] = useState("");
    const [users, setUsers] = useState([]);
    const [userid, setUserid] = useState("");
    const [loading, setLoading] = useState(true);
    const [pageCount, setpageCount] = useState(1);
    const [Navactive, setNavactive] = useState(params.get("vendor-type"));
    const [tableload, setTableLoad] = useState(false);
    const [pushModal, setPushModal] = useState(false);
    const [forcepage, setforcepage] = useState();
    const [pagsize, setpagesize] = useState(1);
    const [showPaginate, setShowPagiate] = useState(true);
    const [searchusers, setSearchusers] = useState([]);
    const [notificationType, setNotificationType] = useState(7);
    const [subcategories, setsubcategories] = useState([]);
    const token = { Authorization: `token ${sessionStorage.getItem("token")}` };

    const headerstyles = {
        color: "#707275",
        fontWeight: 700,
        fontSize: "0.8rem",
    };
    const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;
    const getcategories = () => {
        Services.Get_sub_Categories("GET", null, token)
            .then((res) => {
                if (res.Status === 1) {
                    setsubcategories([
                        ...new Set(
                            res.SubCategories.map(
                                (item) => item.subcategoryname
                            )
                        ),
                    ]);
                } else if (res.Status === 0) {
                    ToastError(res.Message);
                    if (res.Message === "Token expired") {
                        Navigate("/");
                    }
                }
            })
            .catch((err) => {
                // alert(err);
                alert("something went wrong please try again");
                console.log(err);
            });
    };
    const getusers = (skip) => {
        let body = {
            skip: skip,
            vendorType: Navactive,
        };
        setLoading(true);
        if (!showPaginate) {
            setShowPagiate(true);
        }
        Services.getVendors("POST", JSON.stringify(body), token)
            .then((res) => {
                setLoading(false);
                setTableLoad(false);
                console.log(res);
                if (res.Status === 1) {
                    setUsers(res.Vendors);
                    setpagesize(20);
                    setpageCount(Math.ceil(Number(res?.Count) / Number(20)));
                    let pendingUsers = res.Vendors.filter(
                        (item) => item.status == params.get("vendor-type")
                    );

                    setSearchusers(pendingUsers);
                } else if (res.Status === 0) {
                    toast.error(`${res.Message}`, {
                        position: "top-center",
                        autoClose: 1000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    if (res.Message === "Token expired") {
                        Navigate("/");
                    }
                }
            })
            .catch((err) => {
                // alert(err);
                alert("something went wrong please try again");
                console.log(err);
            });
    };

    useEffect(() => {
        if (params.get("search")) {
            setSearchTerm(params.get("search"));
            searchHandler(
                params.get("search"),
                Number(params.get("page") - 1) * 20
            );
        } else {
            getusers(Number(params.get("page") - 1) * 20);
        }
        setforcepage(Number(params.get("page") - 1));
        getcategories();
        if (params.get("page")) {
            setpageCount(Number(params.get("page")));
            // console.log(typeof params.get("page"));
        }
        // eslint-disable-next-line
    }, [Navactive]);
    useEffect(() => {
        let timer = setTimeout(() => {
            setTableLoad(false);
        }, 150);
        return () => {
            clearTimeout(timer);
        };
    }, [searchusers]);

    const viewuserdetails = (e) => {
        Navigate(`/vendor/details?id=${e.currentTarget.getAttribute("id")}`);
    };

    // Handling Search functionality

    function searchHandler(value, skip) {
        setTableLoad(true);
        let body = {
            skip: skip,
            searchstring: value,
        };
        if (!showPaginate) {
            setShowPagiate(true);
        }
        Services.searchVendors("POST", JSON.stringify(body), token)
            .then((res) => {
                console.log(res);
                setTableLoad(false);
                setLoading(false);
                if (res.Status === 1) {
                    setUsers(res.Vendors);
                    setpagesize(20);
                    setpageCount(Math.ceil(Number(res?.Count) / Number(20)));
                    let pendingUsers = res.Vendors.filter(
                        (item) => item.status == params.get("vendor-type")
                    );

                    setSearchusers(pendingUsers);
                } else if (res.Status === 0) {
                    toast.error(`${res.Message}`, {
                        position: "top-center",
                        autoClose: 1000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    if (res.Message === "Token expired") {
                        Navigate("/");
                    }
                }
            })
            .catch((err) => {
                // alert(err);
                setTableLoad(false);
                alert("something went wrong please try again");
                console.log(err);
            });
    }
    const handleInputChange = (event) => {
        const { value } = event.target;

        setSearchTerm(value);
        if (value.length > 0) {
            setparams({ "vendor-type": Navactive, page: 1, search: value });
        } else {
            setparams({ "vendor-type": Navactive, page: 1 });
        }
        setforcepage(0);
        setpageCount(1);
        // Clear the previous timer to avoid multiple calls
        clearTimeout(debounceTimerRef.current);

        // Set a new timer to call the handleSearch function after 500ms
        debounceTimerRef.current = setTimeout(() => {
            if (searchTerm == 0) {
                getusers();
            } else {
                searchHandler(value, 0);
            }
        }, 500);
    };

    const StatusChangeHandler = (e) => {
        const id = e.currentTarget.getAttribute("id");
        let status = e.target.value;
        setTableLoad(true);
        const updatedbody = JSON.stringify({ status: status });
        Services.UpdatevendorDetails("PUT", updatedbody, token, id)
            .then((res) => {
                if (res.Status === 1) {
                    getusers();
                    toast.success(`${res.Message}`, {
                        position: "top-center",
                        autoClose: 1000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                } else if (res.Status === 0) {
                    toast.error(`${res.Message}`, {
                        position: "top-center",
                        autoClose: 1000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    if (res.Message === "Token expired") {
                        Navigate("/");
                    }
                }
            })
            .catch((err) => {
                // alert(err);
                alert("something went wrong please try again");
                console.log(err);
            });
    };
    const handlePageChange = (selectedObject) => {
        console.log(selectedObject);
        setforcepage(selectedObject.selected);
        window.scrollTo({ top: 10, behavior: "instant" });
        // Navigate(`/purchaseorder?page=${selectedObject.selected + 1}`);

        if (searchTerm.length > 0) {
            searchHandler(searchTerm, selectedObject.selected * pagsize);
            setparams({
                page: selectedObject.selected + 1,
                "vendor-type": Navactive,
                search: searchTerm,
            });
        } else {
            getusers(selectedObject.selected * pagsize);
            setparams({
                page: selectedObject.selected + 1,
                "vendor-type": Navactive,
            });
        }
        setTableLoad(true);
    };
    // ------------------code for TABLE formatter--------------------

    const dateFormatter = (cell) => {
        return <Moment format="DD-MM-YYYY">{new Date(cell)}</Moment>;
    };
    const deleteHandler = (e) => {
        let id = e.currentTarget.getAttribute("id");
        let name = e.currentTarget.getAttribute("username");
        swal(`Are You sure you want to Delete ${name}?`, {
            icon: "warning",
            dangerMode: true,
            buttons: {
                cancel: "Cancel",
                catch: {
                    text: "Delete",
                    value: "Delete",
                    className: dashboardclasses["cancel-delete"],
                },
                defeat: false,
            },
        }).then((value) => {
            switch (value) {
                case "Delete":
                    Services.VendorDelete("DELETE", null, token, id)
                        .then((res) => {
                            if (res.Status === 1) {
                                getusers();
                                toast.success(`${res.Message}`, {
                                    position: "top-center",
                                    autoClose: 1000,
                                    hideProgressBar: true,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                });
                            } else if (res.Status === 0) {
                                toast.error(`${res.Message}`, {
                                    position: "top-center",
                                    autoClose: 1000,
                                    hideProgressBar: true,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                });
                                if (res.Message === "Token expired") {
                                    Navigate("/");
                                }
                            }
                        })
                        .catch((err) => {
                            // alert(err);
                            alert("something went wrong please try again");
                            console.log(err);
                        });
                    break;

                // default:
                //     swal("Got away safely!");
            }
        });
    };

    const ActionFormatter = (_, cellcontent) => {
        return (
            <div
                className={dashboardclasses.tablebtns}
                style={{ marginLeft: "1rem" }}>
                <button>
                    <GrFormView
                        size={22}
                        color="grey"
                        id={cellcontent._id}
                        onClick={viewuserdetails}
                    />
                </button>
            </div>
        );
    };

    const radioformatter = (_, cellcontent) => {
        return (
            <div>
                <select
                    style={{ height: "2rem" }}
                    onChange={StatusChangeHandler}
                    id={cellcontent._id}
                    defaultValue={cellcontent.status}
                    ref={statusRef}>
                    <option value={"InActive"}>Inactive</option>
                    <option value={"Active"}>Active</option>
                </select>
            </div>
        );
    };
    const subcategoriesCategories = (cell, cellContent) => {
        return `${cell?.join(",")}`;
    };
    let columns = [
        {
            dataField: "name",
            text: "NAME",
            sort: false,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "mobile",
            text: "MOBILE",
            sort: false,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },

        {
            dataField: "gender",
            text: "GENDER",
            sort: false,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },

        {
            dataField: "ServiceLocationAddress",
            text: "SERVICE LOCATION",
            sort: false,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles, width: "200px" };
            },
        },
        {
            dataField: "Subcategories",
            text: "SUBCATEGORIES",
            sort: false,
            formatter: subcategoriesCategories,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles, width: "200px" };
            },
        },
        {
            dataField: "walletBalance",
            text: "WALLET BALANCE",
            sort: false,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles, width: "200px" };
            },
        },
        {
            dataField: "created",
            text: "CREATED",
            sort: false,
            formatter: dateFormatter,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "userStatus",
            text: "STATUS",
            sort: false,
            formatter: radioformatter,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "ACTIONS",
            text: "VIEW",
            sort: false,
            formatter: ActionFormatter,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles, width: "100px" };
            },
        },
        // {
        //     dataField: "Notify",
        //     text: "ACTIONS",
        //     sort: false,
        //     formatter: pushformatter,
        //     headerStyle: (colum, colIndex) => {
        //         return { ...headerstyles };
        //     },
        // },
    ];

    const navactivehandler = (e) => {
        let status = e.currentTarget.getAttribute("id");
        setNavactive(status);

        if (params.get("search")) {
            setparams({
                "vendor-type": Navactive,
                page: 1,
                search: params.get("search"),
            });
        } else {
            setparams({ "vendor-type": status, page: 1 });
        }
    };
    const emptyDataMessage = () => {
        return "No Data to Display";
    };

    //------------------- filtered Data API CALL---------------------------------------
    const filterHandler = (e) => {
        setShowPagiate(false);
        setTableLoad(true);
        setSearchTerm("");
        setparams({ "vendor-type": Navactive, page: 1 });
        Services.filterVendorByServices(
            "POST",
            JSON.stringify({ subcategoryname: e.target.value }),
            token
        )
            .then((res) => {
                setTableLoad(false);
                if (res.Status === 1) {
                    setUsers(res.Vendors);

                    let pendingUsers = res.Vendors.filter(
                        (item) => item.status == params.get("vendor-type")
                    );

                    setSearchusers(pendingUsers);
                } else if (res.Status === 0) {
                    ToastError(res.Message);
                    if (res.Message === "Token expired") {
                        Navigate("/");
                    }
                }
            })
            .catch((err) => {
                // alert(err);
                setTableLoad(false);
                alert("something went wrong please try again");
                console.log(err);
            });
    };
    return (
        <>
            {pushModal && (
                <Pushmodal
                    setmodal={setPushModal}
                    userid={userid}
                    notificationType={notificationType}
                />
            )}

            <Layout Active={"Vendors"}>
                <div className={dashboardclasses.CategoryWrapper}>
                    <h3>Vendors</h3>
                    {loading ? (
                        <div className={dashboardclasses["loader"]}>
                            <ScaleLoader
                                color={"black"}
                                loading={true}
                                css={override}
                                size={150}
                            />
                        </div>
                    ) : (
                        <>
                            <div
                                className={
                                    dashboardclasses["category-form-two"]
                                }>
                                <input
                                    type={"text"}
                                    placeholder="search by Name/phone"
                                    onChange={handleInputChange}
                                    value={searchTerm}
                                />
                                <select onChange={filterHandler}>
                                    <option value="">
                                        Filter by subcategory
                                    </option>
                                    {subcategories.map((item) => (
                                        <option value={item}>{item}</option>
                                    ))}
                                </select>
                                {/* <button onClick={bulknotifyHandler}>
                                    Bulk Notifications
                                </button> */}
                            </div>
                            <div className={dashboardclasses["orders-navbar"]}>
                                <button
                                    id="InActive"
                                    className={
                                        Navactive === "InActive" &&
                                        dashboardclasses["order-active"]
                                    }
                                    onClick={navactivehandler}>
                                    INACTIVE
                                </button>
                                <button
                                    id="Active"
                                    className={
                                        Navactive === "Active" &&
                                        dashboardclasses["order-active"]
                                    }
                                    onClick={navactivehandler}>
                                    ACTIVE
                                </button>
                            </div>
                            {tableload ? (
                                <div className={dashboardclasses["loader"]}>
                                    <ScaleLoader
                                        color={"black"}
                                        loading={true}
                                        css={override}
                                        size={150}
                                    />
                                </div>
                            ) : (
                                <div className="category-table">
                                    <BootstrapTable
                                        bootstrap4
                                        keyField="id"
                                        data={searchusers}
                                        columns={columns}
                                        wrapperClasses="table-responsive"
                                        noDataIndication={emptyDataMessage}
                                    />
                                    {showPaginate && (
                                        <div
                                            style={{
                                                justifySelf: "right",
                                            }}>
                                            <ReactPaginate
                                                pageCount={pageCount}
                                                marginPagesDisplayed={2}
                                                onPageChange={handlePageChange}
                                                forcePage={forcepage}
                                                breakClassName={"page-item"}
                                                breakLinkClassName={"page-link"}
                                                containerClassName={
                                                    "pagination"
                                                }
                                                pageClassName={"page-item"}
                                                pageLinkClassName={"page-link"}
                                                previousClassName={"page-item"}
                                                previousLinkClassName={
                                                    "page-link"
                                                }
                                                nextClassName={"page-item"}
                                                nextLinkClassName={"page-link"}
                                                activeClassName={"active"}
                                            />
                                        </div>
                                    )}
                                </div>
                            )}
                        </>
                    )}
                </div>
            </Layout>
        </>
    );
}

export default Warehouse;
